// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'

// Unified custom fetch function for all projects
export async function customFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const url = typeof input === 'string' ? input : input.toString()

    const config: RequestInit = {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            ...init?.headers,
        },
    }

    try {
        const response = await fetch(url, config)

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        return response
    } catch (error) {
        console.error('Fetch error:', error)
        throw error
    }
}

// Export as default for consistency
export default customFetch

// Re-export commonly used fetch function
export { customFetch as fetch }
